export default __webpack_public_path__ + "static/media/hollow-candles.35cb92a2.svg";